
export default {
  name: "Sidebar",

  data() {
    return {
      localExtraMenu: null,
      localDefaultMenu: null,
      localDropdownMenus: null,
    }
  },

  computed: {
    isOpen: function () {
      return this.$store.state.sidebar.isOpen || false
    },

    extraMenu: function () {
      return (this.$store.state?.cms?.menus?.['extra-menu']?.items || [])
          .filter((t) => !t.isHidden)
    },
    defaultMenu: function () {
      return (this.$store.state?.cms?.menus?.['default']?.items || [])
          .filter((t) => !t.isHidden)
    },
    dropdownMenus: function () {
      return (this.$store.state?.cms?.menus?.['dropdown-menus']?.items || [])
          .filter((t) => !t.isHidden)
    },

    phomeNumber: function () {
      const number = this.$store.state?.appState?.vars?.['Телефон'];
      if (!number) {
        return number;
      }

      return this.$phoneFormat(number)
    },
    emailAddress: function () {
      return this.$store.state?.appState?.vars?.['Почтовый адрес'] || null
    },
    socials: function () {
      const vars = this.$store.state?.appState?.vars || {};
      const appCfg = this.$store.state?.appState?.config || {};
      let list = [];

      if (vars?.["Почтовый адрес"]) {
        list.push({
          icon: require("~/assets/img/svg/socials/Mail.svg"),
          path: `mailto:${vars?.["Почтовый адрес"]}`
        })
      }
      if (appCfg?.telegram) {
        list.push({
          icon: require("~/assets/img/svg/socials/Telegram.svg"),
          path: appCfg?.telegram
        })
      }
      if (appCfg?.viber) {
        list.push({
          icon: require("~/assets/img/svg/socials/Viber.svg"),
          path: appCfg?.viber
        })
      }
      if (appCfg?.whatsapp) {
        list.push({
          icon: require("~/assets/img/svg/socials/WhatsApp.svg"),
          path: appCfg?.whatsapp
        })
      }

      return list
    },
    whatsapp: function () {
      return this.$store.state?.appState?.config?.whatsapp
    },
    currentCity: function () {
      const appCfg = this.$store.state?.appState?.config || {};
      return appCfg?.city?.model?.name
    },
    telegram: function () {
      const appCfg = this.$store.state?.appState?.config || {};
      return appCfg?.telegram
    },
  },

  components: {
    MenuElement: () => import("~/components/Sidebar/MenuElement")
  },

  methods: {
    closeSidebar: function () {
      this.$store.commit("sidebar/setOpen", false);
    },
    openPopUpCity: function () {
      this.closeSidebar();
      this.$store.commit("city-select/setOpen", true);
    },
    submitApplication: function () {
      this.closeSidebar();
      this.$store.commit("back-call/setOpen", {
        open: true,
        settings: {
          title: "Оставить заявку"
        }
      });
    },
    // создаем локальную копию меню из стора для манипуляций в этом компоненте
    createLocalCopyMenus: function () {
      if (this.extraMenu.length > 0 && this.defaultMenu.length > 0 && this.dropdownMenus.length > 0) {

        // делаем глубокие копии, т.к большая вложенность
        this.localExtraMenu = structuredClone(this.extraMenu);
        this.localDefaultMenu = structuredClone(this.defaultMenu);
        this.localDropdownMenus = structuredClone(this.dropdownMenus);

        let accumMenuPoints = [];

        // ищем пункты перевозок
        let _localExtraMenu = this.localExtraMenu;

        _localExtraMenu.forEach((item) => {
          if (item.path === "napravlenia") {
            item.children.forEach((child) => {
              if (child.path === 'napravlenia/peregon-tehniki-iz-kitaya' || child.path === 'napravlenia/peregon-tehniki-po-rossii-i-sng') {
                accumMenuPoints.push(child);
                return;
              }
            })
          }
        });

        // Убираем искомые пункты из подпунктов в дропдауне
        _localExtraMenu.forEach((item) => {
          if (item.path === 'napravlenia') {
            item.children = item.children.filter((child) => {
              child.children = []; // убираем дропдаун с детьми
              return !accumMenuPoints.some((filteredItem) => filteredItem === child)
            })
          }
        })

        // добавляем искомые пункты в меню на уровень выше и подменяем удаленные
        this.localExtraMenu = accumMenuPoints.concat(_localExtraMenu);

      } else {
        setTimeout(() => {
          this.createLocalCopyMenus();
        }, 500);
      }
    },
  },
  mounted: function () {
    this.createLocalCopyMenus();
  }
}
